




























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { NeueArticle } from '@russmedia-frontend/nordstern-article'
import { ReaderSuggestions } from '@russmedia-frontend/reader-suggestions'

import DCXImageGallery from '~components/content/detail-view/elements/DCXImageGallery.vue'
import ArticleFooter from '~components/content/detail-view/elements/ArticleFooter.vue'
import { Post, Term, PageSettings, DcxImage } from '~base/common/types'
import '@russmedia-frontend/reader-suggestions/nordstern-reader-suggestions.css'
import '@russmedia-frontend/nordstern-article/nordstern-article.css'

interface ExtWindow extends Window {
  Cookiebot: {
    show: () => void
  }
}
declare let window: ExtWindow

@Component({
  components: {
    NeueArticle,
    ArticleFooter,
    DCXImageGallery,
    ReaderSuggestions,
  },
})
export default class Article extends Vue {
  @Prop({ type: Object }) readonly post!: Post
  @Prop({ type: Boolean, default: false })
  readonly displayShortenedContent!: boolean

  @Prop({ type: Boolean, default: false })
  readonly isEverythingPremium!: boolean

  @Prop({ type: Boolean, default: false }) readonly isFree!: boolean

  @Prop({ type: Object, required: false }) readonly pageSettings!:
    | PageSettings
    | undefined

  private showPaywalledContent = false
  private showPaywalledContentClass = 'hidden'
  private showGallery: boolean = false
  private galleryImages: DcxImage[] = []

  @Watch('shortenContent')
  onChildChanged(val: boolean) {
    this.showPaywalledContent = this.isFree || !val
    this.showPaywalledContentClass = this.showPaywalledContent ? '' : 'hidden'
  }

  onAuthorClicked() {
    this.$router.push({
      name: 'author-slug-id',
      params: {
        slug: this.post.author!.node.slug || ``,
        id: `${this.post.author!.node.databaseId}`,
      },
    })
  }

  onGalleryClicked(images: DcxImage[]) {
    this.galleryImages = images
    this.showGallery = true
  }

  onChangeGdpr(_provider: string) {
    window.Cookiebot.show()
    // console.log(`🍪 requested gdpr change`, provider)
  }

  get shortenContent() {
    if (!this.inPreviewContext) {
      return (
        this.$store.getters['paywall/displayShortenedContent'] &&
        this.$store.getters['paywall/showOfferContainer']
      )
    }
    return false
  }

  get categoryClasses() {
    return this.post.categories?.nodes
      ?.map((c) => `category-${c.slug}`)
      .join(' ')
  }

  get isSSR() {
    return process.server
  }

  get inPreviewContext() {
    return this.$store.getters['news/inPreviewContext']
  }

  created() {
    this.showPaywalledContent = this.isSSR
  }

  mounted() {
    this.showPaywalledContent = this.isFree || !this.shortenContent
    this.showPaywalledContentClass = this.showPaywalledContent ? '' : 'hidden'

    if (!this.inPreviewContext) {
      this.$store.commit('news/SET_CURRENT_POST', this.post)

      this.$store.dispatch(
        'tracking/trackArticleView',
        this.createTrackingProperty()
      )
    }
  }

  createTrackingProperty() {
    const from = this.$store.getters['tracking/from']
    const afList = from
      ? from.name === 'index'
        ? 'index'
        : from.name === 'ressort-category'
        ? from.path.replace(/\/ressort\//, '')
        : 'vn'
      : 'vn'
    return {
      post: this.post,
      ga: {
        detail: {
          actionField: { list: afList },
          products: [
            {
              name: this.post.title,
              id: this.post.postId,
              brand: this.post.author?.node.name || 'VN Redaktion',
              category:
                this.post.categories?.nodes
                  ?.map((n: Term) => n.name)
                  .join(', ') || '',
              variant:
                this.post.tags?.nodes?.map((n: Term) => n.name).join(', ') ||
                '',
            },
          ],
        },
      },
    }
  }

  onTitleAction(_e: { [Identifier: string]: string }) {
    // do nothing for now
  }

  get titleComponent(): object | undefined {
    if (
      !this.pageSettings ||
      this.pageSettings.headerComponent === undefined ||
      !this.pageSettings.headerComponentInArticle
    ) {
      return undefined
    }

    if (typeof this.pageSettings.headerComponent === 'function') {
      return this.pageSettings.headerComponent
    }
    return () =>
      import(
        /* webpackChunkName: "tag-[request]" */ `~components/content/widgets/listings/${
          this.pageSettings!.headerComponent
        }.vue`
      )
  }

  get userData() {
    return this.$store.getters['paywall/subscriber']
  }

  get prefillEmail() {
    return this.userData?.email || ''
  }

  get prefillName() {
    const firstName = this.userData?.firstName || ''
    const lastName = this.userData?.lastName || ''
    return `${firstName} ${lastName}`.trim()
  }
}
